export const PriorityType = {
  Low: 0,
  Middle: 1,
  High: 2,
};
